export const sources = {
	webp: "__VITE_ASSET__6bp_5It$EfTQ8f$omStdjw__ 500w, __VITE_ASSET__xUfAOc8vsLn5godiQWqFgA__ 800w, __VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__ 1080w, __VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__ 1200w"
};
export const img = {
	src: "__VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__",
	w: 1200,
	h: 776
};
export default {
	sources: sources,
	img: img
};
